export default __webpack_public_path__ + "static/media/room_bg_2.b1edc4e0.jpg";